var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.pools),function(pool,index){return _c('pool',{key:index,attrs:{"pool":pool}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }